import { Component } from '@angular/core';

@Component({
    selector: 'app-page-side-nav',
    templateUrl: './page-side-nav.component.html',
    styleUrls: ['./page-side-nav.component.scss']
})
export class PageSideNavComponent {
}
